import React, { Component } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/lab/Alert';
import get from 'lodash/get';

import { AMPLIFY_AUTH_EVENT } from '../hooks';
import { setLastLoginEmail } from '../returnPath';

export default class AuthEventView extends Component {
  state = {
    messages: [],
  };

  componentDidMount() {
    window.addEventListener(AMPLIFY_AUTH_EVENT, this.handleAmplifyAuth);
  }

  componentWillUnmount() {
    window.removeEventListener(AMPLIFY_AUTH_EVENT, this.handleAmplifyAuth);
  }

  handleClearAllMessage = () => {
    this.setState({ messages: [] });
  };

  handleAmplifyAuth = ({ detail }) => {
    console.log('auth event', detail);

    const {
      payload: { event, data },
    } = detail;

    // Skip processing if no data (e.g., CN Auth0 users without Cognito session)
    if (!data) {
      console.log('No auth data present, skipping Amplify event handling');
      return;
    }

    if (data.code === 'UserNotConfirmedException') {
      this.setState({
        messages: [
          {
            open: true,
            text:
              'Your account is not verified. We are sending the verification email. Please check your inbox and spam/junk folder.',
            handleClose: this.handleClearAllMessage,
            severity: 'info',
          },
        ],
      });
      return;
    }

    if (event === 'signIn') {
      this.handleClearAllMessage();
      window.signedOutIdle = false;
      return;
    }

    if (event in supressEvents) {
      if (supressEvents[event] === null) {
        return;
      }
    }
    const message =
      data && 'message' in data ? data.message : detail.payload.message;
    let fixed = fixMessage(
      get(errorMessages, [event, data && data.code].join('.')) || message,
    );

    if (event === 'signOut' && window.signedOutIdle) {
      fixed += ' due to inactivity';
    }

    if (data.username) {
      setLastLoginEmail({
        firstName: data.attributes.given_name,
        lastName: data.attributes.family_name,
        email: data.attributes.email,
        type: data.attributes['custom:type'],
        title: data.attributes['custom:title'],
        userId: data.attributes['custom:user_id'],
        accountId: data.attributes['custom:account_id'],
        createdAt: data.attributes['custom:created_at'],
        emailVerified: data.attributes.email_verified,
        sub: data.attributes.sub, // uuid
      });
    }

    if (!this.state.messages.find(({ text }) => text === fixed)) {
      let newMessages = this.state.messages.map(
        ({ open, text, handleClose, severity }) => ({
          open: severity === 'error' ? open : false,
          text,
          handleClose,
          severity,
        }),
      );
      newMessages = newMessages.concat({
        open: true,
        text: fixed,
        severity: /error|fail/i.test(message + event) ? 'error' : 'success',
        handleClose: () => {
          this.setState(s => {
            const newMessages = [...s.messages];
            const index = newMessages.findIndex(x => x.text === fixed);
            if (index === -1) return s;
            newMessages.splice(index, 1);
            return { ...s, messages: newMessages };
          });
        },
      });
      this.setState({ messages: newMessages });
    }
    //    setTimeout(this.patch, 100)
  };

  render() {
    return (
      <>
        {this.state.messages.map(({ open, text, handleClose, severity }) => (
          <Snackbar
            key={text}
            autoHideDuration={6000}
            open={open}
            onClose={handleClose}
          >
            <Alert severity={severity} onClose={handleClose}>
              {text}
            </Alert>
          </Snackbar>
        ))}
      </>
    );
  }
}

const errorMessages = {
  signIn_failure: {
    UserNotFoundException: 'Sign-in failed: invalid email or password',
    NotAuthorizedException: 'Sign-in failed: invalid email or password',
  },
  forgotPassword_failure: {
    UserNotFoundException: 'Reset password failed: invalid email or password',
  },
};

const supressEvents = {
  configured: null,
};

const fixMessage = text =>
  [
    [
      /(.*?)\s+forgotPasswordSubmit successful/,
      'Password was successfully reset for user $1',
    ],
    [
      /(.*?)\s+has initiated forgot password flow/,
      'Please check your inbox ($1) for a 6-digit verification code',
    ],
    [/(.*?)\s+forgotPassword failed/, 'Error while resetting password for $1'],
  ].reduce(
    (result, [what, substitute]) => result.replace(what, substitute),
    text,
  );
